import React from "react";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="site-footer">
        <div className="top-content">
          <div className="container">
            <div className="inner-content">
              <div className="text-wrap">
                <div className="img-box">
                  <img
                    src="./images/site-logo.png"
                    alt="Technominds Logo"
                  />
                </div>
                <p>
                  Techno Inspector  delivers trusted home inspection services with
                  precision and care. We provide clear, detailed reports to help
                  you make confident property decisions. Our team focuses on
                  safety, quality, and long-term reliability.
                </p>
              </div>
              <div className="menu-wrap">
                <h4>MENU LINK</h4>
                
                <ul>
                  <li>
                    <NavLink to="/">Home</NavLink>
                  </li>
                  <li>
                    <NavLink to="/about-us">About us</NavLink>
                  </li>
                  <li>
                    <NavLink to="/commercial">Commercial</NavLink>
                  </li>
                  <li>
                    <NavLink to="/mold-inspections">Mold Inspections</NavLink>
                  </li>
                  <li>
                    <NavLink to="/industerial-building">
                      Industrial Building
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact-us">Contact</NavLink>
                  </li>
                </ul>
              </div>
              <div className="mail-wrap">
                <h4>Lets Get In Touch</h4>
                <ul>
                  <li>
                    <div className="row-001">
                      <span>
                        <i className="fa-solid fa-envelope"></i>
                      </span>
                      <a href="mailto:technoinspections@gmail.com">
                        technoinspections@gmail.com
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="row-001">
                      <span>
                        <i className="fa-solid fa-phone"></i>
                      </span>
                      <a href="tel:+1 (416) 500-1535">+1 (416) 500-1535</a>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="icons-wrap">
                <h4>SOCIAL LINK</h4>
                <ul>
                  <li>
                    <Link
                      to="https://www.facebook.com/login.php?next=https%3A%2F%2Fwww.facebook.com%2Fcheckpoint%2F828281030927956%2F%3Fnext%3Dhttps%253A%252F%252Fwww.facebook.com%252FTechnomindsInspections"
                      target="_blank"
                    >
                      <i className="fa-brands fa-facebook-f"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.instagram.com/thegrayapartments/?igsh=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr#"
                      target="_blank"
                    >
                      <i class="fa-brands fa-instagram"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-wrap">
          <div className="container">
            <h5> Techno Inspector PRIVATE LIMITED</h5>
            <p>
              Copyright @ 2024 - 2025. All Rights Reserved | Privacy Policy |
              Terms & Conditions
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
